<script setup lang="ts">

</script>

<template>
  <div class="flex flex-col items-center justify-center py-12 px-6 text-center">
    <!-- Spinner -->
    <div class="relative w-16 h-16 mb-4">
      <div class="absolute inset-0 border-4 border-gray-200 rounded-full" />
      <div class="absolute inset-0 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>

    <p class="text-gray-500 max-w-sm">
      Récupération de l'historique des rendez-vous
    </p>
  </div>
</template>

<style scoped>

</style>
